import { render, staticRenderFns } from "./MeetingList.vue?vue&type=template&id=b61df2f4"
import script from "./MeetingList.vue?vue&type=script&lang=js"
export * from "./MeetingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports